import React, { useState, useEffect } from "react";
import "./Cards.css";

// Define the content data structure outside the component for cleaner JSX
const cardData = [
    {
        id: 'kaporta',
        header: "Kampanya Paket",
        price: "5000",
        main: false,
        sections: [
            {
                title: "Kaporta & Boya paketi",
                items: []
            },
            {
                title: "Araç Altı Sıvı Kaçak Kontrolleri",
                items: []
            },
            {
                title: "Alt Mekanik Kontrolleri",
                items: []
            },
            {
                title: "Arıza Tespit Cihazı (OBD) Bağlantısı",
                items: []
            },
            {
                title: "UV Işıkla Boya testi",
                items: []
            },
        ]
    },
    {
        id: 'kaporta',
        header: "Ekonomik Paket",
        price: "7500",
        main: false,
        sections: [
            {
                title: "Motor Testi",
                items: [
                    "Araçta Yağ Yakma, Duman Atma,",
                    "Motor Bolgesinde Sesli Çalışma,",
                    "İsteğe Bağlı Motor Performans Testi.",
                ]
            },
            {
                title: "Kaporta Boya Testi",
                items: [
                    "Aracın iç kaporta aksamları kontrolü,",
                    "Aracın alt kaporta aksamları kontrolü,",
                    "Aracın şase podya aksamları kontrolü,",
                    "Aracın dış kaporta aksamları micron değerleri ölçümü.",
                ]
            },
            {
                title: "Test Hatti Kontrolleri",
                items: [
                    "Aracın Muayeneye Engel Teşkil Eden Fren Amortisor Süspansiyon Yana Kayma Kontrolleri",

                ]
            },
            {
                title: "Mekanik Kontrol",
                items: [

                ]
            },
        ]
    },
    {
        id: 'motor',
        header: "Standart Paket",
        price: "9500",
        main: true,
        sections: [
            {
                title: "MOTOR TESTİ",
                items: []
            },
            {
                title: "KAPORTA BOYA TESTİ",
                items: [

                ]
            },
            {
                title: "MEKANİK KONTROL TESTİ",
                items: [

                ]
            },
            {
                title: "OBD CİHAZI BEYİN ARIZA TESTİ",
                items: [

                ]
            },
            {
                title: "YOL TESTİ",
                items: []
            },
            {
                title: "TEST HATTI KONTROLLERİ",
                items: []
            },
            {
                title: "HASAR SORGUSU",
                items: []
            },
            {
                title: "KİLOMETRE SORGUSU",
                items: []
            },
            {
                title: "REMO ASİST ÇEKİCİ HİZMETİ",
                items: []
            },

        ]
    },
    {
        id: 'full',
        header: "Kapsamlı Paket",
        price: "12500",
        main: false,
        sections: [
            {
                title: "MOTOR TESTİ",
                items: []
            },
            {
                title: "KAPORTA BOYA TESTİ",
                items: [

                ]
            },
            {
                title: "MEKANİK KONTROL TESTİ",
                items: [

                ]
            },
            {
                title: "OBD CİHAZI BEYİN ARIZA TESTİ",
                items: [

                ]
            },
            {
                title: "İÇ DIŞ KONDİSYON TESTİ",
                items: []
            },
            {
                title: "CONTA KAÇAK TESTİ",
                items: []
            },
            {
                title: "AIRBAG TESTİ",
                items: []
            },
            {
                title: "TEST HATTI VE MOR IŞIK KONTROLÜ",
                items: []
            },
            {
                title: "YOL TESTİ",
                items: []
            },
            {
                title: "HASAR SORGUSU",
                items: []
            },
            {
                title: "KİLOMETRE SORGUSU",
                items: []
            },
            {
                title: "REMO ASİST ÇEKİCİ HİZMETİ",
                items: []
            },
            {
                title: "REMO ASİST 1 AY 1000KM MOTOR MEKANİK GARANTİ",
                items: []
            },
        ]
    },
    {
        id: 'full',
        header: "Tekli Paketler",
        price: false,
        main: false,
        sections: [
            {
                title: "MOTOR TESTİ",
                items: ["2750₺"]
            },
            {
                title: "DYNO TESTİ",
                items: ["1500₺"]
            },
            {
                title: "KAPORTA TESTİ",
                items: ["4250₺"]
            },
            {
                title: "ARAÇ BEYİN KM KONTROLÜ",
                items: ["1500₺"]
            },
            {
                title: "MEKANİK KONTROL",
                items: [
                    "2750₺",
                ]
            },
            {
                title: "OBD CİHAZI IKG",
                items: ["1500₺"]
            },
            {
                title: "AIRBBAG TESTİ",
                items: ["1000₺"]
            },
            {
                title: "KM VE HASAR KONTROLLERİ",
                items: ["4200₺"]
            },
        ]
    },


];


// --- Start of Main Cards Component ---
export default function Cards() {
    // Initialize expanded cards to include all IDs for desktop default (full expansion)
    const initialExpandedIds = cardData.map(card => card.id);
    const [expandedCardIds, setExpandedCardIds] = useState(initialExpandedIds);

    // Toggle function: adds the ID if collapsed, removes the ID if expanded.
    const toggleExpand = (id) => {
        setExpandedCardIds(prevIds => {
            if (prevIds.includes(id)) {
                // Collapse: remove ID
                return prevIds.filter(cardId => cardId !== id);
            } else {
                // Expand: add ID
                return [...prevIds, id];
            }
        });
    };

    return (
        <div className="cards-container">
            {cardData.map((card) => {
                const isExpanded = expandedCardIds.includes(card.id);
                const cardItemClass = card.main ? "cards-main-item" : "cards-item";
                const priceClass = card.main ? "main-card-price" : "card-price";

                return (
                    <div
                        key={card.id}
                        className={`${cardItemClass} ${isExpanded ? 'expanded' : 'collapsed'}`}
                    >
                        <div className={`cards-content`}>
                            <h1 className="card-header">{card.header}</h1>
                            <ul className="card-explain">
                                <li className="card-explain-item">

                                    {/* Show the placeholder text if NOT expanded */}
                                    {!isExpanded && (
                                        <div className="summary-placeholder">
                                            <h2>Detaylar İçin Tıklayın</h2>
                                        </div>
                                    )}

                                    {/* Show the full details ONLY if expanded */}
                                    {isExpanded && card.sections.map((section, index) => (
                                        <React.Fragment key={index}>
                                            <h2
                                                className={
                                                    section.title === "UV Işıkla Boya testi"
                                                        ? "highlight-purple"
                                                        : ""
                                                }
                                            >{section.title}</h2>
                                            <ul className="card-explain-sublist">
                                                {section.items.map((item, itemIndex) => (
                                                    <li key={itemIndex}>{item}</li>
                                                ))}
                                            </ul>
                                        </React.Fragment>
                                    ))}
                                </li>
                            </ul>
                            <h2 className={priceClass}>{card.price}₺</h2>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}